"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _classnames4 = require("classnames");

var _classnames5 = _interopRequireDefault(_classnames4);

var _components = require("components");

var _Button = require("../../components/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextButton = require("../../components/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _styles = require("./styles.scss");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textButton = (0, _glamor.css)({
  marginLeft: 2,
  marginRight: 2,
  "& button": {
    margin: 0,
    fontFamily: "Roboto, Source Sans Pro, sans-serif;",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px"
  }
});

var TrialCutomPopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(TrialCutomPopup, _React$Component);

  function TrialCutomPopup() {
    (0, _classCallCheck3.default)(this, TrialCutomPopup);
    return (0, _possibleConstructorReturn3.default)(this, (TrialCutomPopup.__proto__ || (0, _getPrototypeOf2.default)(TrialCutomPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrialCutomPopup, [{
    key: "render",
    value: function render() {
      var _classnames,
          _classnames2,
          _classnames3,
          _this2 = this;

      var _props = this.props,
          contactUsPopup = _props.contactUsPopup,
          onCloseYes = _props.onCloseYes;

      var megascans = (0, _classnames5.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, _styles2.default["icon"], true), (0, _defineProperty3.default)(_classnames, _styles2.default["megascans"], true), _classnames));
      var mixer = (0, _classnames5.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, _styles2.default["icon"], true), (0, _defineProperty3.default)(_classnames2, _styles2.default["mixer"], true), _classnames2));
      var bridge = (0, _classnames5.default)((_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, _styles2.default["icon"], true), (0, _defineProperty3.default)(_classnames3, _styles2.default["bridge"], true), _classnames3));

      var getStarted = {
        label: "Get Started",
        onClick: function onClick() {
          var router = _this2.context.router;

          router.push({
            pathname: "/megascans/library"
          });
          onCloseYes();
        },
        primary: true,
        small: true,
        smallSize: true,
        disabled: false
      };

      return _react2.default.createElement(
        _components.Popup,
        null,
        _react2.default.createElement(
          _components.Popup.Header,
          null,
          "Welcome"
        ),
        _react2.default.createElement(
          _components.Popup.Content,
          null,
          _react2.default.createElement(
            "div",
            { className: _styles2.default.container },
            _react2.default.createElement(
              "div",
              { className: _styles2.default.iconContainer },
              _react2.default.createElement("span", { className: megascans })
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.heading },
              "Megascans"
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.para },
              "Access to the free section of the world\u2019s largest and fastest growing scan library."
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.iconContainer },
              _react2.default.createElement("span", { className: bridge })
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.heading },
              "Bridge"
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.para },
              "The complete management and integrations solution."
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.iconContainer },
              _react2.default.createElement("span", { className: mixer })
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.heading },
              "Mixer"
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.para },
              "Blend, paint & sculpt tileable materials in no-time."
            )
          )
        ),
        _react2.default.createElement(
          _components.Popup.Footer,
          null,
          _react2.default.createElement(
            "div",
            { className: _styles2.default.actionButton },
            _react2.default.createElement(_TextButton2.default, {
              className: textButton,
              type: "button",
              label: "Get in touch",
              mode: "small-normal",
              onClick: contactUsPopup
            }),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.button },
              _react2.default.createElement(_Button2.default, getStarted)
            )
          )
        )
      );
    }
  }]);
  return TrialCutomPopup;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
exports.default = TrialCutomPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicEula/TrialPopup/TrialCutomPopup/TrialCutomPopup.jsx
// module id = 2836
// module chunks = 0